import { render, staticRenderFns } from "./ButtonGoTop.vue?vue&type=template&id=804f03b8&"
import script from "./ButtonGoTop.vue?vue&type=script&lang=js&"
export * from "./ButtonGoTop.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGoTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports